angular.module('Itao.IndicatorMap').directive('overviewLayerTypeSelect', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'overviewLayerTypeSelect.html',
    restrict: 'E',
    scope: {
      types: '=',
      year: '=',
      selectedDataLayerType: '=',
      onDataLayerTypeSelect: '&',
      onDistrictSelect: '&',
      blToZoom: '='
    },
    link: function (scope) {
      scope.showResultList = false;
      scope.districts = {};
      scope.selectedUid = null;
      scope.typeUids = mapConfig.availableDataLayerTypeUids;
      scope.searchResults = false;
      scope.blZoomOptions = mapConfig.keyLandMapping;

      var searchObject = {},
          searchObjectFlat = {};

      jQuery.getJSON(mapConfig.templateBasePath + "districtReport/districtReportSearch.json", function(json) {
        searchObject = json;
        convertSearchObject(searchObject);
      });

      scope.findDistrictByValue = function(searchWord){
        if(!searchWord) return;
        districtSearch(searchWord);
      };

      var districtSearch = function(searchWord) {
        if(searchWord.length < 3) return;
        scope.searchResults = [];

        for (var gKey in searchObjectFlat) {
          var resultEntry = searchObject.gemeinden[gKey];
          var regEx = new RegExp('\\b'+searchWord,'gi');
          if (searchObjectFlat[gKey].match(regEx)
            || (searchObject.kreise[resultEntry.kreis] && searchObject.kreise[resultEntry.kreis].match(regEx))) {
            var resultObject = {
              'name': highlightSearchWord(searchWord, resultEntry.name),
              'kreis': {
                'name': highlightSearchWord(searchWord, searchObject.kreise[resultEntry.kreis]),
                'key': resultEntry.kreis
              },
              'jugendamt': {
                'name': searchObject.jugendaemter[resultEntry.jugendamt],
                'key': resultEntry.jugendamt
              }
            };
            if(searchObject.jugendaemter[resultEntry.jugendamt] && searchObject.kreise[resultEntry.kreis]) {
              scope.searchResults.push(resultObject);
            }
          }
        }
      };

      var highlightSearchWord = function(searchWord, hit){
        if(!hit) return;
        var reg = new RegExp('('+searchWord+')', 'gi');
        return hit.replace(reg, '<span class="highlighted">$1</span>');
      };

      scope.selectDistrict = function (district, type) {
        if(type != scope.selectedDataLayerType.uid) {
          scope.selectLayerTypeUid(type);
        }
        // district = 'BE';
        scope.onDistrictSelect({district: district});
      };

      scope.selectLayerTypeUid = function(uid) {
        if(scope.selectedUid != uid) {
          angular.forEach(scope.types, function(type) {
            if(type.uid == uid) {
              scope.onDataLayerTypeSelect({dataLayerType: type});
              scope.selectedUid = uid;
            }
          });
        }
      };

      scope.$watch('selectedDataLayerType', function(dataLayerType) {
        if(dataLayerType != null) {
          scope.selectedUid = dataLayerType.uid;
        }
      });

      scope.$watch('year', function(year) {
        getDistricts();
      });

      scope.$watch('types', function(types) {
        if(!types || !scope.year) return;
        getDistricts();
      }, true);

      function getDistricts() {
        if(!scope.types) return;
        scope.types.forEach(function(type) {
          if(type.layers && type.layers[scope.year] && !scope.districts[type.uid]) {
            scope.districts[type.uid] = Object.keys(type.layers[scope.year].districts).map(function(key) {
              return type.layers[scope.year].districts[key];
            });
          }
        });
      }

      var convertSearchObject = function(searchObject) {
        angular.forEach(searchObject.gemeinden, function(gemeinde, gemeindeKey){
          searchObjectFlat[gemeindeKey] = gemeinde.name;
        });
      };

      scope.onTextClick = function ($event) {
        $event.target.select();
      };
    }
  };
});
